__turbopack_context__.v({
  "answer": "external-chat-module__vO-LfW__answer",
  "assistant": "external-chat-module__vO-LfW__assistant",
  "chat": "external-chat-module__vO-LfW__chat",
  "composer": "external-chat-module__vO-LfW__composer",
  "copilotMark": "external-chat-module__vO-LfW__copilotMark",
  "prompt": "external-chat-module__vO-LfW__prompt",
  "response": "external-chat-module__vO-LfW__response",
  "responseActions": "external-chat-module__vO-LfW__responseActions",
  "sources": "external-chat-module__vO-LfW__sources",
  "tool": "external-chat-module__vO-LfW__tool",
  "transcript": "external-chat-module__vO-LfW__transcript",
});
